import Input from '../../../../components/inputs/Input';
import MultiSelect from '../../../../components/inputs/MultiSelect';
import { SEARCH_FIELDS_PORTFOLIO_INVESTMENT_CRITERIA } from '../../../../utils/constants/fields';

export const getPortfoliosInvestmentCriteriaSearchFields = (state) => {
  // const disableInputsByLoader = state.isLoading || state.isInitialLoading;

  return {
    [SEARCH_FIELDS_PORTFOLIO_INVESTMENT_CRITERIA.INDUSTRY.ID]: (
      <MultiSelect
        field={SEARCH_FIELDS_PORTFOLIO_INVESTMENT_CRITERIA.INDUSTRY}
        value={
          state.portfoliosInvestmentCriteriaFields[
            SEARCH_FIELDS_PORTFOLIO_INVESTMENT_CRITERIA.INDUSTRY.NAME
          ]
        }
        setFieldValue={state.setPortfoliosInvestmentCriteriaFieldValue}
        // disabled={disableInputsByLoader}
        inputWrap={{ enable: true, className: 'col' }}
        wrapClassname="form-group"
      />
    ),
    [SEARCH_FIELDS_PORTFOLIO_INVESTMENT_CRITERIA.HEADQUARTER.ID]: (
      <MultiSelect
        field={SEARCH_FIELDS_PORTFOLIO_INVESTMENT_CRITERIA.HEADQUARTER}
        value={
          state.portfoliosInvestmentCriteriaFields[
            SEARCH_FIELDS_PORTFOLIO_INVESTMENT_CRITERIA.HEADQUARTER.NAME
          ]
        }
        setFieldValue={state.setPortfoliosInvestmentCriteriaFieldValue}
        // disabled={disableInputsByLoader}
        withSingleClear
        inputWrap={{ enable: true, className: 'col' }}
        wrapClassname="form-group"
      />
    ),
    [SEARCH_FIELDS_PORTFOLIO_INVESTMENT_CRITERIA.GEOGRAPHICAL_FOCUS.ID]: (
      <MultiSelect
        field={SEARCH_FIELDS_PORTFOLIO_INVESTMENT_CRITERIA.GEOGRAPHICAL_FOCUS}
        value={
          state.portfoliosInvestmentCriteriaFields[
            SEARCH_FIELDS_PORTFOLIO_INVESTMENT_CRITERIA.GEOGRAPHICAL_FOCUS.NAME
          ]
        }
        setFieldValue={state.setPortfoliosInvestmentCriteriaFieldValue}
        // disabled={disableInputsByLoader}
        inputWrap={{ enable: true, className: 'col' }}
        wrapClassname="form-group"
      />
    ),

    [SEARCH_FIELDS_PORTFOLIO_INVESTMENT_CRITERIA.REVENUE.ID]: (
      <Input
        field={SEARCH_FIELDS_PORTFOLIO_INVESTMENT_CRITERIA.REVENUE}
        value={
          state.portfoliosInvestmentCriteriaFields[
            SEARCH_FIELDS_PORTFOLIO_INVESTMENT_CRITERIA.REVENUE.NAME
          ]
        }
        setFieldValue={state.setPortfoliosInvestmentCriteriaFieldValue}
        // disabled={disableInputsByLoader}
        inputWrap={{ enable: true, className: 'col' }}
      />
    )
  };
};
